<div class="multiselect">
  <p-multiSelect
    [options]="options"
    [formControl]="control"
    [placeholder]="placeholder"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [display]="display"
    [showClear]="showClear"
    [disabled]="disabled"
    [maxSelectedLabels]="maxSelectedLabels"
    (onChange)="onSelectionChange($event)"
    (onClear)="onClear()"
    styleClass="w-100"
    [style]="{'width': '100%'}"


  [ngClass]="{
    'multiselect-default': size === 'default',
    'multiselect-compact': size === 'compact',
    'multiselect-xs': size === 'xs'
  }"
  >
  </p-multiSelect>

</div>
  <div class="error">
    <app-error [control]="control" [type]="'multiselect'"></app-error>
  </div>

